<app-side-menu>
  <div class="cc-view-content">
    <app-controladoria-nav></app-controladoria-nav>

    <header class="ccv-header">
      <div class="d-flex align-items-center flex-wrap gap-3">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar
        </button>
        <div class="flex-grow-1">
          <h1 class="ccv-title mb-1">
            <i class="fas fa-eye me-2"></i>
            Centro de custo
            <span class="text-muted" *ngIf="costCenter">{{ costCenter.code }} — {{ costCenter.name }}</span>
            <span class="text-muted" *ngIf="!costCenter && costCenterCode">({{ costCenterCode }})</span>
          </h1>
          <p class="text-muted mb-0">Consulta, histórico de orçamento e acompanhamento de gastos.</p>
        </div>
        <ng-container *ngIf="costCenter">
          <button
            type="button"
            class="btn btn-primary"
            *appHasPermission="'CostCenters.Manage'"
            (click)="editCostCenter()">
            <i class="fas fa-pen-to-square me-2"></i>
            Editar
          </button>
        </ng-container>
      </div>
    </header>

    <div *ngIf="isLoading" class="text-center py-5">
      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
      <p class="mt-3 text-muted">Carregando centro de custo...</p>
    </div>

    <div *ngIf="error && !isLoading" class="alert alert-danger d-flex justify-content-between align-items-center">
      <span><i class="fas fa-exclamation-triangle me-2"></i>{{ error }}</span>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="loadByCode()">
        <i class="fas fa-redo me-1"></i>
        Tentar novamente
      </button>
    </div>

    <div *ngIf="costCenter && !isLoading" class="row g-4">
      <div class="col-lg-6">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-id-card me-2"></i>Identificação</h5>
          </div>
          <div class="card-body">
            <div class="ccv-field">
              <span class="ccv-label">Código</span>
              <span class="ccv-value">{{ costCenter.code || '—' }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Nome</span>
              <span class="ccv-value">{{ costCenter.name || '—' }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Tipo</span>
              <span class="ccv-value">{{ costCenter.type || '—' }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Departamento</span>
              <span class="ccv-value">{{ costCenter.department || '—' }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Descrição</span>
              <span class="ccv-value">{{ costCenter.description || '—' }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Status</span>
              <span class="badge" [class.bg-success]="costCenter.isActive" [class.bg-secondary]="!costCenter.isActive">
                {{ costCenter.status || '—' }}
                <span *ngIf="costCenter.isActive === false"> (inativo)</span>
              </span>
            </div>
            <div class="ccv-field mb-0" *ngIf="costCenter.parentName">
              <span class="ccv-label">Centro pai</span>
              <span class="ccv-value">{{ costCenter.parentName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-coins me-2"></i>Orçamento e custos</h5>
          </div>
          <div class="card-body">
            <div class="ccv-field">
              <span class="ccv-label">Orçamento mensal</span>
              <span class="ccv-value ccv-value--money">{{ formatMoney(costCenter.monthlyBudget ?? costCenter.budget) }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Orçamento anual</span>
              <span class="ccv-value ccv-value--money">{{ formatMoney(costCenter.annualBudget) }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Custo realizado</span>
              <span class="ccv-value ccv-value--money">{{ formatMoney(costCenter.actualCost) }}</span>
            </div>
            <div class="ccv-field">
              <span class="ccv-label">Moeda</span>
              <span class="ccv-value">{{ displayCurrency() }}</span>
            </div>
            <div class="ccv-field mb-0">
              <span class="ccv-label">Responsável</span>
              <span class="ccv-value">{{ displayResponsibleName() }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="costCenter.notes">
        <div class="card shadow-sm">
          <div class="card-header bg-white">
            <h5 class="mb-0"><i class="fas fa-sticky-note me-2"></i>Observações</h5>
          </div>
          <div class="card-body">
            <p class="mb-0">{{ costCenter.notes }}</p>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card shadow-sm ccv-tracking-card">
          <div class="card-header bg-white d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h5 class="mb-0"><i class="fas fa-chart-pie me-2"></i>Acompanhamento de gastos</h5>
              <small class="text-muted" *ngIf="expenseBreakdown?.includesChildCostCenters">
                Inclui centros de custo filhos
              </small>
            </div>
            <div class="d-flex align-items-center flex-wrap gap-3">
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="includeChildrenBreakdown"
                  [(ngModel)]="includeChildrenInBreakdown"
                  (change)="onIncludeChildrenChange()" />
                <label class="form-check-label" for="includeChildrenBreakdown">
                  Incluir filhos
                </label>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                [disabled]="isLoadingBreakdown"
                (click)="loadExpenseBreakdown(costCenter.id)">
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingBreakdown"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div *ngIf="isLoadingBreakdown" class="text-center py-4 text-muted">
              <i class="fas fa-spinner fa-spin me-2"></i>
              Carregando acompanhamento...
            </div>
            <div *ngIf="breakdownError && !isLoadingBreakdown" class="alert alert-warning mb-0">
              {{ breakdownError }}
            </div>

            <ng-container *ngIf="expenseBreakdown && !isLoadingBreakdown && !breakdownError">
              <div class="row g-3 ccv-kpi-row mb-4">
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi">
                    <span class="ccv-kpi-label">Orçamento consolidado</span>
                    <span class="ccv-kpi-value">{{ formatMoney(expenseBreakdown.consolidatedBudget) }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi ccv-kpi--success">
                    <span class="ccv-kpi-label">Pago</span>
                    <span class="ccv-kpi-value">{{ formatMoney(expenseBreakdown.totalPaid) }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi ccv-kpi--warning">
                    <span class="ccv-kpi-label">Pendente</span>
                    <span class="ccv-kpi-value">{{ formatMoney(expenseBreakdown.totalPending) }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi ccv-kpi--danger">
                    <span class="ccv-kpi-label">Vencido</span>
                    <span class="ccv-kpi-value">{{ formatMoney(expenseBreakdown.totalOverdue) }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi ccv-kpi--primary">
                    <span class="ccv-kpi-label">Saldo disponível</span>
                    <span class="ccv-kpi-value">{{ formatMoney(expenseBreakdown.availableBalance) }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-lg">
                  <div class="ccv-kpi">
                    <span class="ccv-kpi-label">Lançamentos</span>
                    <span class="ccv-kpi-value">{{ expenseBreakdown.totalExpenseCount }}</span>
                  </div>
                </div>
              </div>

              <div class="row g-4 mb-4" *ngIf="expenseBreakdown.byCategory.length || expenseBreakdown.byStatus.length">
                <div class="col-md-6" *ngIf="expenseBreakdown.byCategory.length">
                  <h6 class="ccv-subtitle"><i class="fas fa-tags me-2"></i>Por categoria</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th>Categoria</th>
                          <th class="text-end">Qtd.</th>
                          <th class="text-end">Pago</th>
                          <th class="text-end">Pendente</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let c of expenseBreakdown.byCategory">
                          <td>{{ c.category }}</td>
                          <td class="text-end">{{ c.count }}</td>
                          <td class="text-end">{{ formatMoney(c.totalPaid) }}</td>
                          <td class="text-end">{{ formatMoney(c.totalPending) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="expenseBreakdown.byStatus.length">
                  <h6 class="ccv-subtitle"><i class="fas fa-list-check me-2"></i>Por status</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th>Status</th>
                          <th class="text-end">Qtd.</th>
                          <th class="text-end">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let s of expenseBreakdown.byStatus">
                          <td>
                            <span class="badge" [ngClass]="expenseStatusClass(s.status)">{{ s.status }}</span>
                          </td>
                          <td class="text-end">{{ s.count }}</td>
                          <td class="text-end">{{ formatMoney(s.totalAmount) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <h6 class="ccv-subtitle mb-3"><i class="fas fa-receipt me-2"></i>Detalhamento de despesas</h6>
              <div *ngIf="!expenseBreakdown.items.length" class="text-center py-4 text-muted">
                Nenhuma despesa vinculada a este centro de custo.
              </div>
              <div class="table-responsive" *ngIf="expenseBreakdown.items.length">
                <table class="table table-sm table-hover align-middle mb-0 ccv-expense-table">
                  <thead class="table-light">
                    <tr>
                      <th>Documento</th>
                      <th>Resumo</th>
                      <th>Status</th>
                      <th class="text-end">Impacto</th>
                      <th class="text-end">A pagar</th>
                      <th class="text-end">Pago</th>
                      <th>Vencimento</th>
                      <th class="text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of expenseBreakdown.items">
                      <td>
                        <span class="fw-semibold">{{ item.documentNumber || '—' }}</span>
                        <small class="d-block text-muted" *ngIf="item.invoiceNumber">NF: {{ item.invoiceNumber }}</small>
                      </td>
                      <td class="ccv-expense-summary" [title]="item.expenseSummary || item.description">
                        {{ item.expenseSummary || item.description || '—' }}
                        <small class="d-block text-muted" *ngIf="item.category">{{ item.category }}</small>
                      </td>
                      <td>
                        <span class="badge" [ngClass]="expenseStatusClass(item.status)">{{ item.status }}</span>
                      </td>
                      <td class="text-end">{{ formatMoney(item.expenseImpact) }}</td>
                      <td class="text-end">{{ formatMoney(item.amountToPay) }}</td>
                      <td class="text-end">{{ formatMoney(item.amountPaid) }}</td>
                      <td>{{ formatDate(item.dueDate) }}</td>
                      <td class="text-end">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          title="Ver conta a pagar"
                          (click)="viewAccountsPayable(item.accountsPayableId)">
                          <i class="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header bg-white d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h5 class="mb-0"><i class="fas fa-history me-2"></i>Histórico de orçamento</h5>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [disabled]="isLoadingHistory"
              (click)="loadBudgetHistory(costCenter.id)">
              <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingHistory"></i>
            </button>
          </div>
          <div class="card-body">
            <div *ngIf="isLoadingHistory" class="text-center py-4 text-muted">
              <i class="fas fa-spinner fa-spin me-2"></i>
              Carregando histórico...
            </div>
            <div *ngIf="historyError && !isLoadingHistory" class="alert alert-warning mb-0">
              {{ historyError }}
            </div>
            <div *ngIf="!isLoadingHistory && !historyError && history.length === 0" class="text-center py-4 text-muted">
              Nenhum registro no histórico de orçamento.
            </div>
            <div class="table-responsive" *ngIf="!isLoadingHistory && history.length > 0">
              <table class="table table-sm table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Vigência</th>
                    <th>Tipo</th>
                    <th>Mensal</th>
                    <th>Anual</th>
                    <th>Alterado por</th>
                    <th>Observação</th>
                    <th class="text-end">Proposta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let h of history">
                    <td>{{ h.effectiveAtLabel }}</td>
                    <td><span class="badge bg-light text-dark border">{{ h.changeTypeLabel }}</span></td>
                    <td>{{ h.monthlyLabel }}</td>
                    <td>{{ h.annualLabel }}</td>
                    <td>{{ h.changedByLabel }}</td>
                    <td class="text-truncate ccv-notes" [title]="h.notes">{{ h.notes || '—' }}</td>
                    <td class="text-end">
                      <button
                        type="button"
                        class="btn btn-sm btn-link p-0"
                        *ngIf="h.costCenterBudgetProposalId"
                        (click)="viewProposal(h.costCenterBudgetProposalId)">
                        #{{ h.costCenterBudgetProposalId }}
                      </button>
                      <span *ngIf="!h.costCenterBudgetProposalId">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
